// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questions-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.question-body {
  width: 60%;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  display: flex;
  padding: 10px 15px;
  flex-direction: column;
  gap: 0.7em;
  background: var(--white);
}

.question-body .question {
  font-size: 11px;
  color: var(--text-color);
}
.question-options label {
  color: var(--input-text-color);
}
.question-options {
  display: inline-block;
  margin-right: 10px;
}

.checkbox-wrapper {
  margin-right: 10px;
}

/* Style for the custom checkbox */
.question-options input[type="radio"] {
  opacity: 0;
  position: absolute;
}

.question-options input[type="radio"] + label {
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  display: inline-block;
  line-height: 14px;
  font-size: 14px;
}

.question-options input[type="radio"] + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 2px solid var(--border-color);
  border-radius: 4px;
  background-color: var(--background-app);
}

/* Style for the checkmark inside the checkbox */
.question-options input[type="radio"]:checked + label:before {
  content: "\\2713";
  background-color: var(
    --primary-color
  ); /* Change this line to set the desired color */
  border-color: var(--primary-color); /* Border color when checked */
  font-size: 14px;
  font-weight: 600;
  color: var(--white);
  padding-left: 2px;
}

.question-form {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 2em;
}

.question-submission {
  width: 60%;
}

.question-submission button {
  float: right;
  color: var(--white);
  padding: 8px 23px;
  border-radius: 8px;
  border: none;
  background: var(--primary-color);
  font-size: 14px;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/Calendar/assets/scheduler/css/view/questions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB;;GAEC,EAAE,8CAA8C;EACjD,kCAAkC,EAAE,8BAA8B;EAClE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".questions-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.question-body {\n  width: 60%;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  display: flex;\n  padding: 10px 15px;\n  flex-direction: column;\n  gap: 0.7em;\n  background: var(--white);\n}\n\n.question-body .question {\n  font-size: 11px;\n  color: var(--text-color);\n}\n.question-options label {\n  color: var(--input-text-color);\n}\n.question-options {\n  display: inline-block;\n  margin-right: 10px;\n}\n\n.checkbox-wrapper {\n  margin-right: 10px;\n}\n\n/* Style for the custom checkbox */\n.question-options input[type=\"radio\"] {\n  opacity: 0;\n  position: absolute;\n}\n\n.question-options input[type=\"radio\"] + label {\n  position: relative;\n  padding-left: 25px;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 14px;\n  font-size: 14px;\n}\n\n.question-options input[type=\"radio\"] + label:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--border-color);\n  border-radius: 4px;\n  background-color: var(--background-app);\n}\n\n/* Style for the checkmark inside the checkbox */\n.question-options input[type=\"radio\"]:checked + label:before {\n  content: \"\\2713\";\n  background-color: var(\n    --primary-color\n  ); /* Change this line to set the desired color */\n  border-color: var(--primary-color); /* Border color when checked */\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--white);\n  padding-left: 2px;\n}\n\n.question-form {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  gap: 2em;\n}\n\n.question-submission {\n  width: 60%;\n}\n\n.question-submission button {\n  float: right;\n  color: var(--white);\n  padding: 8px 23px;\n  border-radius: 8px;\n  border: none;\n  background: var(--primary-color);\n  font-size: 14px;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
